import React from 'react';
import { JsonFormsDispatch, withJsonFormsLayoutProps } from '@jsonforms/react';
import { Layout, LayoutProps, UISchemaElement } from '@jsonforms/core';
import styles from '../styles/JsonForm.module.scss';
import { HorizontalLayoutUISchema } from '../form-types';

type Props = Omit<LayoutProps, 'uischema'> & {
  uischema: HorizontalLayoutUISchema<any>;
};

function isLayout(el: UISchemaElement): el is Layout {
  return (el as Layout).elements !== undefined;
}

const HorizontalLayout: React.FC<Props> = ({ schema, path, uischema, renderers, enabled, cells }) => {
  if (!isLayout(uischema)) {
    return null;
  }

  return (
    <div
      className={styles[`horizontalLayout${uischema.variant ?? 'default'}`]}
      style={{ 
        backgroundColor: uischema.background,
        gridTemplateColumns: `repeat(${uischema.templateColCount ?? 4}, 1fr)`
       }}
    >
      {uischema.elements.map((element, index) => (
        <JsonFormsDispatch
            key={`${path}-${index}`}
            uischema={element}
            schema={schema}
            path={path}
            enabled={enabled}
            renderers={renderers}
            cells={cells}
          />
      ))}
    </div>
  );
};

export default withJsonFormsLayoutProps(HorizontalLayout);
